module.exports = __webpack_public_path__ + "static/img/logo_01.1db1d17.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo_01.png
// module id = O4vt
// module chunks = 1